exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n  /* color */\n\n  /* font */\n\n  /* link */\n}\n:root {\n  /* цвет */\n\n  /* TODO в фигме другие цвета по названиям scarlet magenta green beeline aquamarine violet, надо решить с дизайнерами  */\n\n  /* токены со ссылкой на глобал цвета */\n\n  /* шрифт */\n\n  /* отступы от шапки и футера до тела страницы */\n\n  /* ширина тела страницы */\n\n  /* отступы между элементами страницы */\n}\n.PopupButtonLink_btn-link_5JVZ {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n", ""]);

// exports
exports.locals = {
	"btn-link": "PopupButtonLink_btn-link_5JVZ"
};